import { render, staticRenderFns } from "./learnerrecordings.vue?vue&type=template&id=01eb5d6b&scoped=true&"
import script from "./learnerrecordings.vue?vue&type=script&lang=ts&"
export * from "./learnerrecordings.vue?vue&type=script&lang=ts&"
import style0 from "./learnerrecordings.vue?vue&type=style&index=0&id=01eb5d6b&lang=scss&scoped=true&"
import style1 from "./learnerrecordings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb5d6b",
  null
  
)

export default component.exports